export const STORYBLOK_PAGES = [
  "airPassengerRights",
  "affiliate",
  "help",
  "privacy",
  "terms",
  "referralTerms",
  "affiliateTerms",
  "affiliatePrivacy",
  "airhelpPlus",
  "airPayout",
  "helpAFriend",
  "airhelpReviews",
  "ourFees",
  "aboutUs",
  "press",
  "legalPartners",
  "becomeAPartner",
  "forAirlines",
  "cookies",
  "planYourTrip",
  "brazilianTerms",
  "brazilianPriceList",
  "airhelpPlusTerms",
] as const;

export const REGULAR_PAGES = [
  "cookies", // the only Storyblok page in Regular pages due to Context issues
  "airlineStrikeCompensation",
  "airlines",
  "airports",
  "webapp",
  "webappNewClaim",
  "webappBarcodeScanner",
  "webappBarcodeUploader",
  "ahpBuyEssential",
  "ahpBuyComplete",
  "careers",
] as const;

export type RegularPageName = typeof REGULAR_PAGES[number];
export type StoryblokPageName = typeof STORYBLOK_PAGES[number];

export type PageName = RegularPageName | StoryblokPageName;

export type RegularPageUrls = {
  fallback?: string;
  isExternal?: boolean;
  isMagnitude?: boolean;
  parentLanguageOnly?: boolean;
  [key: string]: string | boolean;
} & ({ passLanguageToUrl: true; baseUrl: string; isExternal: true } | { passLanguageToUrl?: false });
